import axios from "axios";
import { serviceKeys } from "../../constants";

export const signUp = async (payload) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/signup/`,
    payload
  );
  return response.data;
};

export const logIn = async (payload) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/login/`,
    payload
  );
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/reset-password/`,
    { token, password: password }
  );
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post(
    `${serviceKeys.BASE_URL}api/v1/storefront/auth/forgot-password/`,
    { email }
  );
  return response.data;
}

export const getMyOrders = async (token) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/my-orders/`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
};

export const getMyTickets = async (token) => {
  const response = await axios.get(
    `${serviceKeys.BASE_URL}api/v1/storefront/my-tickets/`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}